"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.backofficeTaskqueue_de_de = void 0;
function backofficeTaskqueue_de_de() {
    return {
        "backoffice.taskqueue.title": "Warteschlange",
        "backoffice.taskqueue.subtitle": "Übersicht zu Aufgaben wie Datenexporte oder Workflows, die als Hintergrundaktivitäten ausgeführt werden.",
        "backoffice.taskqueue.start": "Startzeit",
        "backoffice.taskqueue.owner": "Ausgeführt durch",
        "backoffice.taskqueue.type": "Typ",
        "backoffice.taskqueue.status": "Status",
        "backoffice.taskqueue.payload": "Informationen",
        "backoffice.taskqueue.nopayload": "Keine Detail-Infos vorhanden",
        "backoffice.taskqueue.statushistory": "Statusverlauf",
        "backoffice.taskqueue.source": "Datenquelle",
        "backoffice.taskqueue.conversion": "Konvertierung",
        "backoffice.taskqueue.recipient": "Empfänger",
        "backoffice.taskqueue.method": "Methode",
        "backoffice.taskqueue.url": "URL"
    };
}
exports.backofficeTaskqueue_de_de = backofficeTaskqueue_de_de;
